import React, { useState } from 'react';

const RetryModal = ({ isOpen, setIsOpen, retry }) => {
  
  const handleRetry = () => {
    retry()
    setTimeout(() => setIsOpen(false), 1000);
  };

  if (!isOpen) return null;

  return (
    <> 
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 transform transition-all">
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="bg-red-100 rounded-full p-3">
              <i className="bi bi-exclamation-circle text-red-600 text-5xl"></i>
            </div>
          </div>
          
          <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
            Network Error - Submission!!
          </h2>
          <p className="text-gray-600 text-center mb-6">
            Ensure your network is stable before retrying the submission.
          </p>
          <button
            onClick={handleRetry}
            className="w-full bg-primary hover:opacity-90 text-white font-medium py-3 px-4 rounded-lg transition-opacity duration-200 flex items-center justify-center gap-2"
          >
            <i className="bi bi-arrow-clockwise text-xl"></i>
            Retry Submission
          </button>
        </div>
      </div>
    </>
  );
};

export default RetryModal;